module.exports = __webpack_public_path__ + "static/media/catalogueImg7.0bc292e5.png";